export default {
  INTERNET_STATUSES: [
    { KEY: 0, VALUE: 'INDEFINIDO', color: 'grey' },
    { KEY: 1, VALUE: 'OPERACIONAL', color: '#36BD3B' },
    { KEY: 2, VALUE: 'PENDENTE', color: '#EEB759' },
    { KEY: 3, VALUE: 'NÃO OPERACIONAL', color: '#A62A2A' },
  ],
  CONECTIVITY_STATUSES: [
    { KEY: 0, VALUE: 'Pendente', color: '#EEB759' },
    { KEY: 1, VALUE: 'Online', color: '#009317' },
    { KEY: 2, VALUE: 'Offline', color: '#D10000' },
    { KEY: 3, VALUE: 'Sem Conexão', color: '#AAB8C2' },
  ],

  OPERATINOL_STATUS: [
    { KEY: 'configured', VALUE: 'Em Operação' },
    { KEY: 'installed', VALUE: 'Instalado' },
    { KEY: 'uninstalled', VALUE: 'Aguardando Instalação' },
  ],

  GPS_STATUSES: [
    { KEY: 0, VALUE: 'INDEFINIDO', color: 'grey' },
    { KEY: 1, VALUE: 'Ativo', color: '#36BD3B' },
    { KEY: 2, VALUE: 'SINAL INVÁLIDO', color: '#A62A2A' },
    { KEY: 3, VALUE: 'SEM COMUNICAÇÃO', color: '#828282' },
  ],
  INSTALLATION_STATUSES: [
    { KEY: 0, VALUE: 'DISPONÍVEL' },
    { KEY: 1, VALUE: 'INSTALADO' },
    { KEY: 2, VALUE: 'CONFIGURADO' },
  ],
  STATUS_DATA_MAP: new Map([
    ['applicationVersion', 'Versão do aplicativo'],
    ['dbdId', 'DBD'],
    ['dbdIp', 'Endereço IP'],
    ['dbdState', 'Estado do DBD'],
    ['diskUsage', 'Uso de disco'],
    ['gpsStatus', 'Status do GPS'],
    ['internetStatus', 'Status de conexão'],
    ['sdReadOnly', 'Cartão apenas leitura'],
    ['noSDCard', 'Sem cartão SD'],
    ['sdProblem', 'Cartão SD com problema'],
    ['settingsVersion', 'Versão de configurações'],
    ['temperature', 'Temperatura'],
    ['timestamp', 'Atualizado em'],
    ['uptime', 'Tempo em execução'],
    ['validationNumber', 'Número de validação'],
  ]),

  WAY: [
    { KEY: 0, VALUE: 'Entrada' },
    { KEY: 1, VALUE: 'Saída' },
  ],
  TYPE: [
    { KEY: 0, VALUE: 'Primário' },
    { KEY: 1, VALUE: 'Secundário' },
  ],
};

const CONST_DBD_OBJECT = {
  INTERNET_STATUS: {
    UNDEFINED: { KEY: 0, VALUE: 'INDEFINIDO' },
    OK: { KEY: 1, VALUE: 'OPERACIONAL' },
    DELAYED: { KEY: 2, VALUE: 'PENDENTE' },
    NOK: { KEY: 3, VALUE: 'NÃO OPERACIONAL' },
  },
  GPS_STATUS: {
    UNDEFINED: { KEY: 0, VALUE: 'INDEFINIDO' },
    OK: { KEY: 1, VALUE: 'OPERACIONAL' },
    DELAYED: { KEY: 2, VALUE: 'PENDENTE' },
    NOK: { KEY: 3, VALUE: 'NÃO OPERACIONAL' },
  },
  INSTALLATION_STATUSES: {
    AVAILABLE: { KEY: 0, VALUE: 'DISPONÍVEL' },
    INSTALLED: { KEY: 1, VALUE: 'INSTALADO' },
    CONFIGURED: { KEY: 2, VALUE: 'CONFIGURADO' },
  },
  WAY: {
    ENTER: { KEY: 0, VALUE: 'Entrada' },
    EXIT: { KEY: 1, VALUE: 'Saída' },
  },
  TYPE: {
    PRIMARY: { KEY: 0, VALUE: 'Primário' },
    SECONDARY: { KEY: 1, VALUE: 'Secundário' },
  },
};
const VERSION = [
  { KEY: 0, VALUE: 'Requisitado' },
  { KEY: 1, VALUE: 'Download' },
  { KEY: 2, VALUE: 'Atualizado' },
];

export { CONST_DBD_OBJECT, VERSION };
